const awsmobile ={
  aws_project_region: 'us-east-1',
  aws_cognito_region: 'us-east-1',
  aws_user_pools_id: 'us-east-1_WZm326oEq',
  aws_user_pools_web_client_id: 'vm73j5s05lqu5r7bs8a0hvqsv',
  oauth: {
    domain: 'cognito.sandbox.youscience.com',
    scope: [ 'email', 'openid', 'profile', 'aws.cognito.signin.user.admin' ],
    redirectSignIn: 'https://signin.sandbox.youscience.com',
    redirectSignOut: 'https://signin.sandbox.youscience.com/logout',
    responseType: 'code'
  },
  federationTarget: 'COGNITO_USER_POOLS',
  aws_cognito_username_attributes: [ 'EMAIL' ],
  aws_cognito_social_providers: [ 'GOOGLE' ],
  providers: [
    'Google',
    'Office365',
    'Clever',
    'ClassLink',
    'GG4L',
    'GADOE',
    'Skyward'
  ],
  discoveryServiceUrl: 'https://login.sandbox.youscience.com',
  brightPathUrl: 'https://brightpath.sandbox.youscience.com',
  gusServiceUrl: 'https://admin.sandbox.youscience.com',
  gusHostName: 'https://apigw.sandbox.youscience.com/gus',
  enableGusIntegration: true,
  enableRosteringWithGus: true,
  clever_client_id: '5b8f18cb9daa2b527740',
  allowed_callback_urls: '',
  allowed_signout_urls: '',
  classlink_sso_launch_url: 'https://cognito.sandbox.youscience.com/oauth2/authorize?identity_provider=ClassLink&redirect_uri=https://signin.sandbox.youscience.com&response_type=CODE&client_id=vm73j5s05lqu5r7bs8a0hvqsv&scope=aws.cognito.signin.user.admin email openid profile',
  aws_cognito_signup_attributes: [ 'EMAIL' ],
  aws_cognito_mfa_configuration: 'OPTIONAL',
  aws_cognito_mfa_types: [ 'SMS', 'TOTP' ],
  aws_cognito_password_protection_settings: { passwordPolicyMinLength: 8, passwordPolicyCharacters: [] },
  aws_cognito_verification_mechanisms: [ 'EMAIL' ],
  aws_content_delivery_bucket: 'identity-service-hosting-bucket-sandbox',
  aws_content_delivery_bucket_region: 'us-east-1',
  api_host: 'https://signin.sandbox.youscience.com',
  aws_dynamodb_all_tables_region: 'us-east-1',
  aws_dynamodb_table_schemas: [
    { tableName: 'isp-codes-sandbox', region: 'us-east-1' },
    { tableName: 'isp-clients-sandbox', region: 'us-east-1' }
  ],
  ssoLoginWaitTime: { clever: '3200', classlink: '5000' },
  enableEmployerPage: true,
  waitingRoomEnabled: true,
  waitingRoomPublicUrl: 'https://d3og484xugm0nu.cloudfront.net',
  waitingRoomEventId: 'user-login-waiting-room',
  skipUserEmailVerification: false,
  mfaEnabled: true,
  deploymentStage: 'sandbox',
  mfaValidityDays: 1
}
export default awsmobile;